import { CUSTOM_VENDOR_CONNECTION_APP_ID } from 'custom-vendor-connection-lib';
import { GOOGLE_SHEETS_APP_ID } from 'google-sheets-integration-lib';
import { MICROSOFT_DRIVE_APP_ID } from 'microsoft-drive-auth-lib';
import { SURVEY_MONKEY_APP_ID } from 'surveymonkey-integration-lib';
import { REDDIT_ADS_APP_ID, CHATGPT_ADS_APP_ID, MICROSOFT_ADS_APP_ID } from 'ads-unified-auth-lib';
import enviro from 'enviro';
var ENV;
(function (ENV) {
  ENV["PROD"] = "PROD";
  ENV["QA"] = "QA";
})(ENV || (ENV = {}));
const CURRENT_ENV = enviro.isQa() ? ENV.QA : ENV.PROD;
const ZOOMINFO_APP_IDS = {
  [ENV.QA]: 31562779,
  [ENV.PROD]: 30423594
};
const SLACK_INTEGRATION_APP_IDS = {
  [ENV.QA]: 1162214,
  [ENV.PROD]: 60729
};
const GEMINI_APP_IDS = {
  [ENV.QA]: 22723359,
  [ENV.PROD]: 12747241
};
const COHERE_APP_IDS = {
  [ENV.QA]: 17729414,
  [ENV.PROD]: 10960790
};
const X_AI_APP_IDS = {
  [ENV.QA]: 17550320,
  [ENV.PROD]: 10704890
};
const ADOBE_SIGN_APP_IDS = {
  [ENV.QA]: 10021866,
  [ENV.PROD]: 3560422
};
export const getZoomInfoAppId = () => ZOOMINFO_APP_IDS[CURRENT_ENV];
export const getMicrosoftDriveAppId = () => MICROSOFT_DRIVE_APP_ID;
export const getGoogleSheetsAppId = () => GOOGLE_SHEETS_APP_ID;
export const getSlackIntegrationAppId = () => SLACK_INTEGRATION_APP_IDS[CURRENT_ENV];
export const getSurveyMonkeyAppId = () => SURVEY_MONKEY_APP_ID;
export const getRedditAdsAppId = () => REDDIT_ADS_APP_ID;
export const getChatGptAdsAppId = () => CHATGPT_ADS_APP_ID;
export const getMicrosoftAdsAppId = () => MICROSOFT_ADS_APP_ID;
export const getAdobeSignAppId = () => ADOBE_SIGN_APP_IDS[CURRENT_ENV];
export const getGeminiAppId = () => GEMINI_APP_IDS[CURRENT_ENV];
export const getCohereAppId = () => COHERE_APP_IDS[CURRENT_ENV];
export const getXAiAppId = () => X_AI_APP_IDS[CURRENT_ENV];
export const getCustomVendorConnectionAppId = () => CUSTOM_VENDOR_CONNECTION_APP_ID;

// Dashworks/Breeze Apps
export const INTEGRATIONS_DASHWORKS = {
  ASANA_BREEZE: 'ASANA_BREEZE',
  AZURE_DEVOPS_BREEZE: 'AZURE_DEVOPS_BREEZE',
  BOX_BREEZE: 'BOX_BREEZE',
  CONFLUENCE_BREEZE: 'CONFLUENCE_BREEZE',
  DOCUMENT360_BREEZE: 'DOCUMENT360_BREEZE',
  DROPBOX_BREEZE: 'DROPBOX_BREEZE',
  GITBOOK_BREEZE: 'GITBOOK_BREEZE',
  GMAIL_BREEZE: 'GMAIL_BREEZE',
  GOOGLE_DRIVE_BREEZE: 'GOOGLE_DRIVE_BREEZE',
  GURU_BREEZE: 'GURU_BREEZE',
  HELPJUICE_BREEZE: 'HELPJUICE_BREEZE',
  JIRA_BREEZE: 'JIRA_BREEZE',
  LINEAR_BREEZE: 'LINEAR_BREEZE',
  MSTEAMS_BREEZE: 'MSTEAMS_BREEZE',
  ONEDRIVE_BREEZE: 'ONEDRIVE_BREEZE',
  OUTLOOK_BREEZE: 'OUTLOOK_BREEZE',
  PRODUCTBOARD_BREEZE: 'PRODUCTBOARD_BREEZE',
  README_BREEZE: 'README_BREEZE',
  SHAREPOINT_BREEZE: 'SHAREPOINT_BREEZE',
  SLACK_BREEZE: 'SLACK_BREEZE',
  SMARTSHEET_BREEZE: 'SMARTSHEET_BREEZE',
  STACKOVERFLOW_TEAMS_BREEZE: 'STACKOVERFLOW_TEAMS_BREEZE'
};
export const DASHWORKS_APPS_DATA = {
  [INTEGRATIONS_DASHWORKS.ASANA_BREEZE]: {
    displayName: 'Asana (for Breeze)',
    appIds: {
      QA: 21361649,
      PROD: 15757528
    }
  },
  [INTEGRATIONS_DASHWORKS.AZURE_DEVOPS_BREEZE]: {
    displayName: 'Azure DevOps (for Breeze)',
    appIds: {
      QA: 20332460,
      PROD: 14658526
    }
  },
  [INTEGRATIONS_DASHWORKS.BOX_BREEZE]: {
    displayName: 'Box (for Breeze)',
    appIds: {
      QA: 21361762,
      PROD: 16147293
    }
  },
  [INTEGRATIONS_DASHWORKS.CONFLUENCE_BREEZE]: {
    displayName: 'Confluence (for Breeze)',
    appIds: {
      QA: 19956024,
      PROD: 14114216
    }
  },
  [INTEGRATIONS_DASHWORKS.DROPBOX_BREEZE]: {
    displayName: 'Dropbox (for Breeze)',
    appIds: {
      QA: 21361684,
      PROD: 16147236
    }
  },
  [INTEGRATIONS_DASHWORKS.GMAIL_BREEZE]: {
    displayName: 'Gmail (for Breeze)',
    appIds: {
      QA: 19767525,
      PROD: 13823852
    }
  },
  [INTEGRATIONS_DASHWORKS.GOOGLE_DRIVE_BREEZE]: {
    displayName: 'Google Drive (for Breeze)',
    appIds: {
      QA: 19768331,
      PROD: 13824211
    }
  },
  [INTEGRATIONS_DASHWORKS.JIRA_BREEZE]: {
    displayName: 'Jira (for Breeze)',
    appIds: {
      QA: 20331833,
      PROD: 14657622
    }
  },
  [INTEGRATIONS_DASHWORKS.LINEAR_BREEZE]: {
    displayName: 'Linear (for Breeze)',
    appIds: {
      QA: 21559382,
      PROD: 16432607
    }
  },
  [INTEGRATIONS_DASHWORKS.MSTEAMS_BREEZE]: {
    displayName: 'Microsoft Teams (for Breeze)',
    appIds: {
      QA: 19768560,
      PROD: 13823956
    }
  },
  [INTEGRATIONS_DASHWORKS.ONEDRIVE_BREEZE]: {
    displayName: 'OneDrive (for Breeze)',
    appIds: {
      QA: 19768777,
      PROD: 13824019
    }
  },
  [INTEGRATIONS_DASHWORKS.OUTLOOK_BREEZE]: {
    displayName: 'Outlook (for Breeze)',
    appIds: {
      QA: 19768635,
      PROD: 13824166
    }
  },
  [INTEGRATIONS_DASHWORKS.PRODUCTBOARD_BREEZE]: {
    displayName: 'Productboard (for Breeze)',
    appIds: {
      QA: 21741290,
      PROD: 16628418
    }
  },
  [INTEGRATIONS_DASHWORKS.SHAREPOINT_BREEZE]: {
    displayName: 'SharePoint (for Breeze)',
    appIds: {
      QA: 19768705,
      PROD: 13824042
    }
  },
  [INTEGRATIONS_DASHWORKS.SLACK_BREEZE]: {
    displayName: 'Slack (for Breeze)',
    appIds: {
      QA: 19764048,
      PROD: 13697285
    }
  },
  [INTEGRATIONS_DASHWORKS.SMARTSHEET_BREEZE]: {
    displayName: 'Smartsheet (for Breeze)',
    appIds: {
      QA: 21559054,
      PROD: 16432527
    }
  },
  [INTEGRATIONS_DASHWORKS.DOCUMENT360_BREEZE]: {
    displayName: 'Document360 (for Breeze)',
    appIds: {
      QA: 22050238,
      PROD: 17045734
    }
  },
  [INTEGRATIONS_DASHWORKS.GITBOOK_BREEZE]: {
    displayName: 'GitBook (for Breeze)',
    appIds: {
      QA: 22050242,
      PROD: 17045735
    }
  },
  [INTEGRATIONS_DASHWORKS.GURU_BREEZE]: {
    displayName: 'Guru (for Breeze)',
    appIds: {
      QA: 21714619,
      PROD: 16617295
    }
  },
  [INTEGRATIONS_DASHWORKS.HELPJUICE_BREEZE]: {
    displayName: 'Helpjuice (for Breeze)',
    appIds: {
      QA: 22050244,
      PROD: 17045736
    }
  },
  [INTEGRATIONS_DASHWORKS.README_BREEZE]: {
    displayName: 'ReadMe (for Breeze)',
    appIds: {
      QA: 22050245,
      PROD: 17045737
    }
  },
  [INTEGRATIONS_DASHWORKS.STACKOVERFLOW_TEAMS_BREEZE]: {
    displayName: 'Stack Overflow for Teams (for Breeze)',
    appIds: {
      QA: 22050247,
      PROD: 17045740
    }
  }
};
export const INTEGRATIONS_MCP = {
  AGENT_AI_MCP: 'AGENT_AI_MCP',
  AMPLITUDE_MCP: 'AMPLITUDE_MCP',
  ASANA_MCP: 'ASANA_MCP',
  ATLASSIAN_MCP: 'ATLASSIAN_MCP',
  BOX_MCP: 'BOX_MCP',
  CANVA_MCP: 'CANVA_MCP',
  CLAY_MCP: 'CLAY_MCP',
  FATHOM_MCP: 'FATHOM_MCP',
  G2_MCP: 'G2_MCP',
  GMAIL_MCP: 'GMAIL_MCP',
  GONG_MCP: 'GONG_MCP',
  GOOGLE_CALENDAR_MCP: 'GOOGLE_CALENDAR_MCP',
  GOOGLE_CHAT_MCP: 'GOOGLE_CHAT_MCP',
  GOOGLE_DOCS_MCP: 'GOOGLE_DOCS_MCP',
  GOOGLE_DRIVE_MCP: 'GOOGLE_DRIVE_MCP',
  GOOGLE_PEOPLE_MCP: 'GOOGLE_PEOPLE_MCP',
  GOOGLE_SHEETS_MCP: 'GOOGLE_SHEETS_MCP',
  GOOGLE_SLIDES_MCP: 'GOOGLE_SLIDES_MCP',
  HUBSPOT_INTERNAL_MCP: 'HUBSPOT_INTERNAL_MCP',
  LINEAR_MCP: 'LINEAR_MCP',
  NETSUITE_MCP: 'NETSUITE_MCP',
  NOTION_MCP: 'NOTION_MCP',
  SLACK_MCP: 'SLACK_MCP',
  XERO_MCP: 'XERO_MCP',
  ZAPIER_MCP: 'ZAPIER_MCP',
  ZOOM_MCP: 'ZOOM_MCP'
};
export const MCP_APPS_DATA = {
  [INTEGRATIONS_MCP.AGENT_AI_MCP]: {
    displayName: 'Agent.ai (MCP)',
    appIds: {
      QA: 25924866,
      PROD: 22859539
    }
  },
  [INTEGRATIONS_MCP.AMPLITUDE_MCP]: {
    displayName: 'Amplitude (MCP)',
    appIds: {
      QA: 26982887,
      PROD: 25088849
    }
  },
  [INTEGRATIONS_MCP.ASANA_MCP]: {
    displayName: 'Asana (MCP)',
    appIds: {
      QA: 25923980,
      PROD: 22859566
    }
  },
  [INTEGRATIONS_MCP.ATLASSIAN_MCP]: {
    displayName: 'Atlassian (MCP)',
    appIds: {
      QA: 25919238,
      PROD: 22859613
    }
  },
  [INTEGRATIONS_MCP.BOX_MCP]: {
    displayName: 'Box (MCP)',
    appIds: {
      QA: 43776525,
      PROD: 48797804
    }
  },
  [INTEGRATIONS_MCP.CANVA_MCP]: {
    displayName: 'Canva (MCP)',
    appIds: {
      QA: 45620968,
      PROD: 51631587
    }
  },
  [INTEGRATIONS_MCP.CLAY_MCP]: {
    displayName: 'Clay (MCP)',
    appIds: {
      QA: 42653980,
      PROD: 47368126
    }
  },
  [INTEGRATIONS_MCP.FATHOM_MCP]: {
    displayName: 'Fathom (MCP)',
    appIds: {
      QA: 42654196,
      PROD: 47368147
    }
  },
  [INTEGRATIONS_MCP.G2_MCP]: {
    displayName: 'G2 (MCP)',
    appIds: {
      QA: 26982973,
      PROD: 25088826
    }
  },
  [INTEGRATIONS_MCP.GMAIL_MCP]: {
    displayName: 'Gmail (MCP)',
    appIds: {
      QA: 38857422,
      PROD: 41552388
    }
  },
  [INTEGRATIONS_MCP.GONG_MCP]: {
    displayName: 'Gong (MCP)',
    appIds: {
      QA: 27954766,
      PROD: 25369029
    }
  },
  [INTEGRATIONS_MCP.GOOGLE_CALENDAR_MCP]: {
    displayName: 'Google Calendar (MCP)',
    appIds: {
      QA: 38316493,
      PROD: 40688392
    }
  },
  [INTEGRATIONS_MCP.GOOGLE_CHAT_MCP]: {
    displayName: 'Google Chat (MCP)',
    appIds: {
      QA: 38857420,
      PROD: 41552377
    }
  },
  [INTEGRATIONS_MCP.GOOGLE_DOCS_MCP]: {
    displayName: 'Google Docs (MCP)',
    appIds: {
      QA: 48673672,
      PROD: 55980869
    }
  },
  [INTEGRATIONS_MCP.GOOGLE_DRIVE_MCP]: {
    displayName: 'Google Drive (MCP)',
    appIds: {
      QA: 36931178,
      PROD: 38619069
    }
  },
  [INTEGRATIONS_MCP.GOOGLE_PEOPLE_MCP]: {
    displayName: 'Google People (MCP)',
    appIds: {
      QA: 38857413,
      PROD: 41552386
    }
  },
  [INTEGRATIONS_MCP.GOOGLE_SHEETS_MCP]: {
    displayName: 'Google Sheets (MCP)',
    appIds: {
      QA: 48673750,
      PROD: 55980933
    }
  },
  [INTEGRATIONS_MCP.GOOGLE_SLIDES_MCP]: {
    displayName: 'Google Slides (MCP)',
    appIds: {
      QA: 48673804,
      PROD: 55981019
    }
  },
  [INTEGRATIONS_MCP.HUBSPOT_INTERNAL_MCP]: {
    displayName: 'HubSpot Internal (MCP)',
    appIds: {
      QA: 45419593,
      PROD: 51308067
    }
  },
  [INTEGRATIONS_MCP.LINEAR_MCP]: {
    displayName: 'Linear (MCP)',
    appIds: {
      QA: 27954784,
      PROD: 25287964
    }
  },
  [INTEGRATIONS_MCP.NETSUITE_MCP]: {
    displayName: 'NetSuite (MCP)',
    appIds: {
      QA: 40642046,
      PROD: 44324228
    }
  },
  [INTEGRATIONS_MCP.NOTION_MCP]: {
    displayName: 'Notion (MCP)',
    appIds: {
      QA: 25919243,
      PROD: 22859648
    }
  },
  [INTEGRATIONS_MCP.SLACK_MCP]: {
    displayName: 'Slack (MCP)',
    appIds: {
      QA: 26674538,
      PROD: 50648916
    }
  },
  [INTEGRATIONS_MCP.XERO_MCP]: {
    displayName: 'Xero (MCP)',
    appIds: {
      QA: 42653975,
      PROD: 47368139
    }
  },
  [INTEGRATIONS_MCP.ZAPIER_MCP]: {
    displayName: 'Zapier (MCP)',
    appIds: {
      QA: 25919248,
      PROD: 22859706
    }
  },
  [INTEGRATIONS_MCP.ZOOM_MCP]: {
    displayName: 'Zoom (MCP)',
    appIds: {
      QA: 44656869,
      PROD: 50557984
    }
  }
};
export const INTEGRATIONS = Object.assign({}, DASHWORKS_APPS_DATA, MCP_APPS_DATA);
export const getAppIdByAppName = appName => INTEGRATIONS[appName].appIds[CURRENT_ENV];